/**
 * Recently Viewed Products Utility
 * Handles saving and managing recently viewed products in localStorage.
 * Separated from template markup for better maintainability and performance.
 */

/**
 * Loads recently viewed products from localStorage
 * @returns {Array} Array of recently viewed product objects
 */
function loadRecentlyViewed() {
  const storedData = localStorage.getItem('__recently_viewed_products__');
  if (storedData) {
    return JSON.parse(storedData);
  } else {
    return [];
  }
}

/**
 * Saves recently viewed products to localStorage
 * @param {Array} data - Array of product objects to save
 */
function saveRecentlyViewed(data) {
  localStorage.setItem('__recently_viewed_products__', JSON.stringify(data));
}

/**
 * Adds a product to the recently viewed list
 * - Removes duplicate if product already exists
 * - Adds product to the end of the list
 * - Maintains maximum of 14 products (removes oldest if exceeded)
 * @param {Object} product - Product object to add
 */
function addRecentlyViewed(product) {
  let recentlyViewed = loadRecentlyViewed();
  
  // Check if product is already in the list
  const existingProductIndex = recentlyViewed.findIndex(p => p.id === product.id);
  if (existingProductIndex > -1) {
    // Remove the product if it exists
    recentlyViewed.splice(existingProductIndex, 1);
  }
  
  // Add the product to the end of the list
  recentlyViewed.push(product);
  
  // Keep only the last 14 products
  if (recentlyViewed.length > 14) {
    recentlyViewed.shift(); // Remove the oldest product
  }
  
  saveRecentlyViewed(recentlyViewed);
}
